var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2859 14.6428H11.7145",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71436 18.9289L6.71436 16.0718",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71436 11.7856L7.42864 13.2142",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6862 3.2571L19.3862 1.09996C19.4997 1.06419 19.6207 1.05992 19.7365 1.0876C19.8522 1.11528 19.9583 1.17386 20.0433 1.2571C20.1331 1.33586 20.2012 1.43627 20.2412 1.54879C20.2812 1.66132 20.2918 1.7822 20.2719 1.89996L18.7005 9.91424C18.6147 9.69995 18.529 9.47138 18.4576 9.24281C18.0025 7.58357 17.038 6.1091 15.7 5.02745C14.362 3.94579 12.7182 3.31156 11.0005 3.21424C9.2827 3.31156 7.63887 3.94579 6.3009 5.02745C4.96292 6.1091 3.99836 7.58357 3.54331 9.24281C3.47188 9.48567 3.38617 9.69995 3.30046 9.92853L1.72903 1.89996C1.70913 1.7822 1.71968 1.66132 1.75969 1.54879C1.7997 1.43627 1.86783 1.33586 1.9576 1.2571C2.04264 1.17386 2.14869 1.11528 2.26443 1.0876C2.38016 1.05992 2.50124 1.06419 2.61474 1.09996L10.3147 3.2571",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1429 18.6858C11.7327 19.0097 10.2674 19.0097 8.85718 18.6858",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2856 18.9289L15.2856 16.0718",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2858 11.7856L14.5715 13.2142",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.bd7cc8a1fab6515228d7a12067584958.svg";
export { ForwardRef as ReactComponent };